<template>
  <div>
    <rest-form-item
      :label="$t('ChannelConfig_MobivateVortex_ApiKey')"
      prop="api_key"
    >
      <el-input
        v-model="model.params.api_key"
        :placeholder="$t('ChannelConfig_MobivateVortex_ApiKey_Placeholder')"
      />
    </rest-form-item>
    <rest-form-item
      :label="$t('ChannelConfig_MobivateVortex_IgnorePermanentBounce')"
      prop="ignore_permanent_bounce"
    >
      <rest-form-select-boolean
        v-model="model.params.ignore_permanent_bounce"
      />
    </rest-form-item>
  </div>
</template>

<script>
import RestFormItem from '@/common/components/rest/RestFormItem'
import RestFormSelectBoolean from '@/common/components/rest/RestFormSelectBoolean'

export default {
  components: { RestFormItem, RestFormSelectBoolean },
  props: {
    model: {
      type: Object,
      required: true
    }
  },

  created() {
    if (!this.$route.query.id) {
      this.$set(this.model, 'type', 'sms')
      this.$set(this.model, 'channel', 'mobivate_vortex')
      this.$set(this.model, 'params', { ignore_permanent_bounce: 0 })
    } else {
      const params = this.model.params || {}

      if (!Object.hasOwn(params, 'ignore_permanent_bounce')) {
        params['ignore_permanent_bounce'] = 0
        this.$set(this.model, 'params', params)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/channels/providers/MobivateVortex.vue